module.exports = __webpack_public_path__ + "static/media/avocado_regular_plan.10a2f618.jpg";